export interface MenuGateInputs {
    enabled: boolean;
    captureEnabled: boolean | null | undefined;
    uploadEnabled: boolean | null | undefined;
    deleteEnabled: boolean | null | undefined;
    hasFile: boolean;
    userMediaAvailable: boolean;
}

interface MenuGates {
    capture: boolean;
    captureNotAvailable: boolean;
    upload: boolean;
    download: boolean;
    edit: boolean;
    delete: boolean;
}

// Flags use "!== false" so definitions saved before a flag existed keep the item enabled.
export function menuGates(inputs: MenuGateInputs): MenuGates {
    const captureConfigured = inputs.enabled && inputs.captureEnabled !== false;

    return {
        capture: captureConfigured && inputs.userMediaAvailable,
        captureNotAvailable: captureConfigured && !inputs.userMediaAvailable,
        upload: inputs.enabled && inputs.uploadEnabled !== false,
        download: inputs.hasFile,
        edit: inputs.hasFile && inputs.enabled,
        delete: inputs.hasFile && inputs.enabled && inputs.deleteEnabled !== false
    };
}
